import React,  { useState } from "react";
import { TextField, DialogContent, Dialog, Typography, Button } from "@material-ui/core";
import useStyles from "../styles";
import { checkDocument, getDocument  } from "../api";

const PasswordDialog = ({handleState, hash}) => {
    const [state, setState] = handleState;
    const  [value, setValue] = useState('');
    const cl = useStyles()
    const handleClose = () => {
        setState(p=>({
            ...p,
            dialog: false,
            dialogData: {
                f1: '',
                f2: ''
            }
        }))
    }

    const handleChange = (e) => {
        e.persist();
        e.stopPropagation();
        e.preventDefault();

        setValue(e.target.value)
    }

    const handleConfirmReport = async () => {
        try {
            await sessionStorage.setItem('partnerPassword'+hash, value)
            setState((p) => ({
                ...p,
                l: true,
            }));
            const check = await checkDocument(hash)
            const data = await getDocument(hash);
            
            setState((p) => ({
                ...p,
                l: false,
                data,
                password: value,
                check
            }));
            handleClose()
        } catch (e) {
            console.error(e);
            sessionStorage.removeItem('partnerPassword'+hash)

            setState((p) => ({
            ...p,
            l: false,
            password: '',
            e,
            }))
        }
    }

    return <Dialog open={true} onClose={handleClose} style={{zIndex: 1}}>
        <DialogContent className={cl.dialogContent}>
            <Typography variant="h6">Підтвердження даних</Typography>
            <Typography variant="body1">Розрахунок: {state?.dialogData?.priceCalc}</Typography>
            <TextField
                value={value}
                onChange={handleChange}
                label="Пароль"
                name="password"
                variant="outlined"
                size="small"
                fullWidth
                margin="normal"
                placeholder="********"
            />
            <Button
                variant="contained"
                color="primary"
                style={{ marginTop: '16px',alignSelf: 'flex-end' }}
                onClick={handleConfirmReport}
                disabled={value === 0}
            >
                Ввести
            </Button>
            {state?.e && <Typography variant="error" color="error" style={{maxWidth: '300px', margin: '8px 0px'}}>{state?.e?.response?.data?.message}</Typography>}
        </DialogContent>
    </Dialog>
}

export default PasswordDialog;
